// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Service Items
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

function serviceItems(showMarkers, serviceSection) {
  


  // Animate individual items
  var serviceItems = serviceSection.querySelectorAll(".service-item");

  serviceItems.forEach((serviceItem, i) => { 

    const serviceItemEntry = gsap.timeline({
      paused: "true",
      scrollTrigger: {
        trigger: serviceItem,
        toggleActions: "play pause resume resume",
        id: "service-item",
        //pinReparent: true,
        markers: showMarkers,
      },
    });

      gsap.set(serviceItem, {opacity:0, y: 76});
      serviceItemEntry.to(serviceItem, {opacity: 1, y:0, duration: 1, delay: .5}, 0)

      var serviceItemImg = serviceItem.querySelector("img");

      gsap.set(serviceItemImg, {scale: 1.2});
      serviceItemEntry.to(serviceItemImg, {scale: 1, duration: 1.2, delay: .75}, 0)
  });

  // Animate card links
  var serviceCardBtn = serviceSection.querySelector(".card-btn");

  if(serviceCardBtn){

    const serviceCardEntry = gsap.timeline({
      paused: "true",
      scrollTrigger: {
        trigger: serviceCardBtn,
        toggleActions: "play pause resume resume",
        id: "service-item",
        markers: showMarkers,
      },
    });

    gsap.set(serviceCardBtn, { scale: 0.6, opacity: 0, transformOrigin: "0% 80%" });
    serviceCardEntry.to(serviceCardBtn,{scale: 1, opacity: 1, duration: 1.2, delay: .5}, 0);
  }

}

export { serviceItems };
